import { datalakeApiClient } from '@/lib/api/lib/client'
import type { V1DatalakeItem } from '@/lib/api/lib/models'
import { PROGRAMME_PROGRESS_KIND } from '@/lib/programmeSnapshots'

type DatalakeItemsQuery = {
    kind: string[]
    version?: string
    corellationId?: string
    lastUpdatedAfter?: number
}

type DatalakeItemsPageQuery = DatalakeItemsQuery & {
    items: number
    skip: number
}

type DatalakeItemsPage = { items?: V1DatalakeItem[] }
type FetchDatalakeItemsPage = (
    query: DatalakeItemsPageQuery
) => Promise<DatalakeItemsPage>

export async function loadAllDatalakeItems(
    query: DatalakeItemsQuery,
    fetchPage: FetchDatalakeItemsPage = (request) =>
        datalakeApiClient.getDatalakeItems(request),
    pageSize = 100
): Promise<V1DatalakeItem[]> {
    const result: V1DatalakeItem[] = []
    const seenIds = new Set<string>()

    for (let skip = 0; ; skip += pageSize) {
        const page = await fetchPage({ ...query, items: pageSize, skip })
        const items = page.items || []
        let added = 0
        for (const item of items) {
            if (seenIds.has(item.id)) continue
            seenIds.add(item.id)
            result.push(item)
            added += 1
        }
        if (items.length < pageSize) return result
        if (added === 0) {
            throw new Error('Datalake pagination did not advance')
        }
    }
}

export async function loadAllProgrammeProgressItems(
    query: Omit<DatalakeItemsQuery, 'kind' | 'version'> = {},
    fetchPage?: FetchDatalakeItemsPage,
    pageSize = 100
): Promise<V1DatalakeItem[]> {
    return loadAllDatalakeItems(
        {
            ...query,
            kind: [PROGRAMME_PROGRESS_KIND],
            version: '0.0.1'
        },
        fetchPage,
        pageSize
    )
}
